// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1koe-","search":"Settings_search__3-VpZ","filter":"Settings_filter__F1GA4"};